import React, { useLayoutEffect } from 'react';
import { WebView } from 'react-native-webview';
import HeaderAccentTitle from '../../shared/HeaderAccentTitle';

const CheckInWebModal = ({ navigation }) => {
  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => <HeaderAccentTitle title="Check-In" subtitle="aa.com" />,
    });
  }, [navigation]);

  return (
    <WebView
      startInLoadingState
      source={{ uri: `https://www.aa.com/reservation/flightCheckInViewReservationsAccess.do` }}
    />
  );
};

export default CheckInWebModal;
